import { Component, OnInit , inject} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthBllService } from '../auth-bll.service';
import { LoaderComponent } from '../../../shared/components/loader/loader.component';
import { LoaderService } from '../../../shared/components/loader/loader.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-init',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './init.component.html',
  styleUrls: ['./init.component.scss'],
})
export class InitComponent implements OnInit {
  /** Indicates whether the login redirect flow is in progress. */
  // isLoading = true;
  /** Error message to display if initiating the login flow fails. */
  error: string | null = null;
  private loaderService = inject(LoaderService);

  /**
   * @param route         ActivatedRoute instance for inspecting query parameters if needed.
   * @param authService   Business-logic service that handles PKCE/OAuth flows.
   * @param router        Angular Router for navigation upon errors or completion.
   */
  constructor(
    private route: ActivatedRoute,
    private authService: AuthBllService,
    private router: Router
  ) {}

  /**
   * On component initialization, begin the PKCE-based authentication
   * by generating a verifier/challenge and redirecting the user.
   *
   * Catches any synchronous errors thrown during setup and displays
   * an alert instead of redirecting.
   */
  ngOnInit(): void {
    this.loaderService.show();
    try {
      this.authService.startAuthenticate();
    } catch (err: any) {
      // Capture any error from the PKCE setup or redirect
      this.error = err.message || 'Failed to initiate login.';
      this.loaderService.hide();
    }
  }
}
